import React, { Fragment } from 'react';

import smallGraf from '../../assets/contact/graf-4-small.svg';
import arrowGraf from '../../assets/contact/graf-arrow.svg';
import graf from '../../assets/contact/graf-4.svg';
import Animate from '../Animate';

const Contact = ({ t, width }) => (
    <Fragment>
        <div id="contact" className="landing-container-contact">
            <div className="landing-layout">
                <div className="landing-page-contact">
                    <div className="landing-contact-header">
                        <Animate>
                            <h2 className="landing-section-title">{t("landing.contact.title")}</h2>
                        </Animate>
                        <p className="landing-section-text">{t("landing.contact.subtitle")}</p>
                    </div>
                    <div>
                        {
                            (width === 'phone')
                                ? <img
                                    className="landing-page-contact-image"
                                    src={smallGraf}
                                    alt=""
                                />
                                : <img
                                    className="landing-page-contact-image"
                                    src={graf}
                                    alt=""
                                />
                        }
                    </div>
                    <img
                        className="landing-section-image"
                        src={arrowGraf}
                        alt=""
                    />
                </div>
            </div>
        </div>
    </Fragment>

);

export default Contact;
